<template>
    <div v-if="!props.docs" class="d-flex justify-content-center align-items-center col-12" style="height: 100px;">
        <p><i class="fas fa-spinner fa-pulse"></i> Aguarde</p>
    </div>
    <div class="mt-4 col-12 col-xl-12 mt-xl-0">
        <div class="card h-100">
            <div class="p-3 card-body">
                <template v-if="props.docs && props.docs.length <= 0">
                    <div class="d-flex justify-content-center align-items-center segment-primary-color">
                        <i class="fa fa-exclamation-circle fa-2x" aria-hidden="true"></i>
                        <span class="text-center font-weight-bolder" style="margin-left: 10px;">
                            Nenhum documento encontrado!
                        </span>
                    </div>
                </template>
                <template v-else>
                    <ul v-for="file in props.docs" :key="file.id" class="list-group">
                        <li class="px-0 mb-2 border-0 list-group-item d-flex align-items-center">
                            <i class="fa fa-files-o fa-2x" aria-hidden="true"></i>
                            <div class="d-flex align-items-start flex-column justify-content-center"
                                style="margin-left: 20px;">
                                <h6 class="mb-0 text-sm">{{ file.name }}</h6>
                                <p class="mb-0 text-xs">Documento {{ file.type }}</p>
                            </div>
                            <a class="mb-0 btn btn-link pe-3 ps-0 ms-auto" target="_blank" :href=file.url>Abrir</a>
                        </li>
                    </ul>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>

// import Skeleton from 'primevue/skeleton';

const props = defineProps({
    docs: {
        type: Object,
        required: false
    }
});

</script>

<style>
.mr-custom {
    margin-right: 1.25rem;
}

.list-none {
    list-style-type: none;
}
</style>